import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { CircularProgress } from "@mui/material";
import EmptyState from '../empty-state/EmptyState';
import { HealthChart } from "./HealthChart";
import { MetricsService } from '@common/data-access';
export function HealthChartContainer({ 
  store = {},
  productAccess = {},
}) {

    const [metrics, setMetrics] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const loadMetrics = async () => {
            try {
                setIsLoading(true);
                const competitorIds = store.competitors?.map(c => c.id) || [];
                const response = await MetricsService.getCompetitorHealth({
                    product: productAccess.internalName,
                    storeId: store.id,
                    competitorIds
                });
                setMetrics(response.competitors || []);
            } catch (err) {
                console.error('Error loading metrics:', err);
            } finally {
                setIsLoading(false);
            }
        };

        if (store?.id && store?.competitors?.length > 0) {
            loadMetrics();
        } else {
            setIsLoading(false);
        }

    }, [store]);
    
  if (isLoading) {
    return (
      <div className="health-report-body__chart-container">
        <div className="progress-container">
          <CircularProgress/>
        </div>
      </div>
    );
  }

  if (metrics.length === 0) {
    return (
        <EmptyState
          icon="📊"
          title="No hay datos disponibles"
          description="No se encontraron datos de metricas para mostrar"
        />
    );
  }

  return (
    <div className="health-report-body__chart-container">
      <h5>Estado de actualización de datos</h5>
      <p className="chart-description">
        Estos son los datos de actualización de los competidores de tu tienda
      </p>
      <HealthChart metrics={metrics} store={store} />
    </div>
  );
}

HealthChartContainer.propTypes = {
  store: PropTypes.object,
  productAccess: PropTypes.object,
};

export default HealthChartContainer;